import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * 認証が必要なルートを保護するコンポーネント
 * 未認証の場合はログイン画面にリダイレクト
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // 認証状態確認中はローディング表示
  if (isLoading) {
    return (
      <div className="aip-html-body" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'var(--font-family-sans)',
      }}>
        <div>読み込み中...</div>
      </div>
    );
  }

  // 未認証の場合はログイン画面にリダイレクト
  if (!isAuthenticated) {
    // 現在のパスを state に保存して、ログイン後にリダイレクトできるようにする
    return <Navigate to="/meeting/manage-new/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;




